module.exports = __webpack_public_path__ + "static/media/sqlite.2e48e46a.svg";